import React, { Component } from 'react'
// import toastr from 'toastr'
import moment from "moment"
import DatePicker from 'react-datepicker'
import { AgGridReact } from "ag-grid-react"
import { Button, Dropdown, Form } from "semantic-ui-react"
import ApiHelper from "services/api-helper"
import FileSaver from "file-saver"
import toastr from 'toastr'
import { session } from "services/session"

class QuanLyNgayPhep extends Component {
  state = {
    rowData: [],
    columnDefs: [
      { checkboxSelection: true, minWidth: 40, maxWidth: 40 },
      {
        headerName: "#",
        minWidth: 50,
        maxWidth: 50,
        suppressSorting: true,
        cellRenderer: function (params) {
          return params.rowIndex + 1;
        }
      },
      { headerName: "Họ tên", field: "HoTen" },
      { headerName: "Bộ phận", field: "TenBoPhan" },
      { headerName: "Số ngày nghỉ có phép", field: "SoNgayNghiCoPhep" },
      { headerName: "Số ngày nghỉ khác", field: "SoNgayNghiKhac" }
    ],
    boPhanList: [],
    boPhanSelected: null,
    startDate: moment().startOf('year'),
    endDate: moment().endOf('year'),
  }
  onGridReady = (params) => {
    this.gridApi = params.api
    this.gridColumnApi = params.columnApi
    this.getListBoPhan()
  }
  autoSizeAll() {
    this.gridApi.sizeColumnsToFit()
    var widthAfterSizeColsToFit = this.gridColumnApi.getAllColumns().map(column => column.getActualWidth()).reduce((a, b) => a + b, 0)
    this.gridColumnApi.autoSizeAllColumns()
    var widthAfterAutoSize = this.gridColumnApi.getAllColumns().map(column => column.getActualWidth()).reduce((a, b) => a + b, 0)
    if (widthAfterSizeColsToFit > widthAfterAutoSize) {
      this.gridApi.sizeColumnsToFit()
    }
  }
  getListBoPhan() {
    ApiHelper.GetJson('api/getDanhSachBoPhanByUser').then(res => {
      if (res.length > 1) res.unshift({ Oid: null, TenBoPhan: 'Tất cả' })
      this.setState({ boPhanList: res, boPhanSelected: res.length > 0 ? res[0].Oid : null })
      this.getData()
    }, error => {
      toastr.error(error)
    })
  }
  getData = () => {
    ApiHelper.GetJson('api/tongSoNgayDaNghiCuaNhanVien', {
      IDBoPhan: this.state.boPhanSelected,
      IDNhanVien: session.WebGroupID === '00000000-0000-0000-0000-000000000008' ? session.NhanVienId : null,
      TuNgay: this.state.startDate,
      DenNgay: this.state.endDate
    }).then(res => {
      this.setState({ rowData: res })
      this.autoSizeAll()
    }, error => {
      toastr.error(error)
    })
  }
  exportExcel = () => {
    ApiHelper.Get('api/tongSoNgayDaNghiCuaNhanVienExcel', {
      IDBoPhan: this.state.boPhanSelected,
      IDNhanVien: session.WebGroupID === '00000000-0000-0000-0000-000000000008' ? session.NhanVienId : null,
      TuNgay: this.state.startDate,
      DenNgay: this.state.endDate
    }).then(res => res.blob()).then(res => {
      var date = new Date()
      var fileName = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}_${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}.xlsx`
      FileSaver.saveAs(res, fileName)
    }, error => {
      toastr.error(error)
    })

    // var blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" });
    // FileSaver.saveAs(res.blob(), "hello world.xlsx");
    // console.log(this.gridApi.getDataAsCsv())
    // this.gridApi.exportDataAsCsv()

    // var workbook = new Excel.Workbook();
    // workbook.csv.read(this.gridApi.getDataAsCsv()).then((sheet) => {
    //   workbook.xlsx.write(sheet).then((rest) => {
    //     console.log(rest)
    //   })
    // })
  }
  handleBoPhanSelected = (e, { value }) => {
    return this.setState({ boPhanSelected: value })
  }
  handleChange = (_ref) => {
    var startDate = _ref.startDate || this.state.startDate
    var endDate = _ref.endDate || this.state.endDate

    if (startDate.isAfter(endDate)) {
      _ref.startDate && (endDate = startDate)
      _ref.endDate && (startDate = endDate)
    }

    this.setState({ startDate: startDate, endDate: endDate })
  }
  handleChangeStart = (startDate) => {
    return this.handleChange({ startDate })
  }
  handleChangeEnd = (endDate) => {
    return this.handleChange({ endDate })
  }
  render() {
    const boPhanList = this.state.boPhanList.map(item => {
      return { value: item.Oid, text: item.TenBoPhan }
    })
    return (
      <div>
        <Form>
          <Form.Group className="ui center aligned grid">
            <Form.Field>
              <Button onClick={this.exportExcel} positive>Export Excel</Button>
            </Form.Field>
          </Form.Group>
          <Form.Group className="ui center aligned grid">
            {boPhanList.length > 0 ? <Form.Field>
              <Dropdown selection options={boPhanList} placeholder={boPhanList.map(q => q.text)[0]}
                value={this.state.boPhanSelected}
                onChange={this.handleBoPhanSelected}
              />
            </Form.Field> : <span></span>}
            <Form.Field>
              <DatePicker
                selected={this.state.startDate}
                selectsStart
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onChange={this.handleChangeStart}
                dateFormat="DD/MM/YYYY"
                placeholderText="Từ ngày"
              />
            </Form.Field>
            <Form.Field>
              <DatePicker
                selected={this.state.endDate}
                selectsEnd
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onChange={this.handleChangeEnd}
                dateFormat="DD/MM/YYYY"
                placeholderText="Đến ngày"
              />
            </Form.Field>
            <Form.Field>
              <Button onClick={this.getData} color="twitter">Tìm</Button>
            </Form.Field>
          </Form.Group>
        </Form>
        <div className="ag-theme-balham" style={{ height: '500px' }}>
          <AgGridReact
            enableSorting={true}
            rowSelection="multiple"
            enableFilter={true}
            enableColResize={true}
            suppressColumnVirtualisation={true}
            onGridReady={this.onGridReady}
            columnDefs={this.state.columnDefs}
            rowData={this.state.rowData}>
          </AgGridReact>
        </div>
      </div>
    )
  }
}

export default QuanLyNgayPhep


// WEBPACK FOOTER //
// ./src/components/quan-ly-ngay-phep/index.jsx